export interface CorrespondentRemittance {
    correspondentId: number;
    feature: string;
    enabled: boolean;
}

export interface BasicPerson {
    full_name: string;
    document: string;
    complement: string;
    country: string;
    documentType: string;
}

export interface RemittanceBasicPerson {
    documentNumber: string;
    complement: string;
    expedition: string;
    birthdate: Date | null;
    cellPhone: string;
    email: string;
    address: string;
}

export interface CorrespondentRemittanceState {
    data: any;
    loading: boolean;
    error: string | null;
}

export const FETCH_CORRESPONDENT_REQUEST = 'FETCH_CORRESPONDENT_REQUEST';
export const FETCH_CORRESPONDENT_SUCCESS = 'FETCH_CORRESPONDENT_SUCCESS';
export const FETCH_CORRESPONDENT_FAILURE = 'FETCH_CORRESPONDENT_FAILURE';

interface FetchCorrespondentRequestAction {
    type: typeof FETCH_CORRESPONDENT_REQUEST;
}

interface FetchCorrespondentSuccessAction {
    type: typeof FETCH_CORRESPONDENT_SUCCESS;
    payload: CorrespondentRemittance;
}

interface FetchCorrespondentFailureAction {
    type: typeof FETCH_CORRESPONDENT_FAILURE;
    payload: string;
}

export type CorrespondentRemittanceActionTypes =
    | FetchCorrespondentRequestAction
    | FetchCorrespondentSuccessAction
    | FetchCorrespondentFailureAction;